module.exports = __webpack_public_path__ + "img/spins.7eafd826.png";